module.exports = __webpack_public_path__ + "img/perforaciones_16-9.6ee4d7d0.jpg";